export const init = {
  campaignName: "",
  platform: "tiktok", grokPlan: "free", totalDuration: "12",
  funnel: "",
  productName: "", productCategory: "", productCategoryCustom: "",
  keyColors: "", keyFeaturesCustom: "", usp: "", productRules: "",
  targetAudience: [],
  videoStyle: "", tone: [], realism: "", colorGrading: [], authenticity: "",
  settingPreset: "", settingCustom: "", settingDetail: "", bgActivity: "",
  lightingPreset: "", lightingCustom: "",
  talent: "", talentStyle: [], talentDetail: "", emotion: [],
  shotType: [], cameraAngle: "", cameraMove: "", heroAngle: "", productFraming: [],
  subjectMotion: [], productInteraction: [],
  hook: [], problemStatement: "", keyBenefit: "", emotionalArc: "", endingFrame: "", cta: [],
  audioType: "", voLang: "", voTone: "", speechType: "", bgMusic: "", customVO: "",
  frameRate: "", resolution: "", depthOfField: "",
  referenceUrl: "", brandStyle: "",
  antiHallucination: [], restrictions: [], extraNotes: "",
  storyline: "",
};


export const soraInit = {
  productDescription: "",
  productUSP: "",
  productCategory: "",
  videoModel: "wan",    // 'wan' | 'kling' | 'hailuo'
  salesFunnel: "lower",
  videoRatio: "9_16",
  videoLength: "10",
  aiDecideStoryline: true,
  userStoryline: "",
  // Advanced (optional)
  videoStyle: "", tone: "", cameraMotion: "", lightingStyle: "",
  backgroundSetting: "", audienceEmotion: "", restrictions: "",
};

